const { default: CustomPaginationContainer } = require("./container");

// Custom pagination component
const CustomPagination = ({ pageSize, currentPage, onClick, total }) => {
  const totalPages = Math.ceil(total / pageSize);
  const startEntry = currentPage * pageSize + 1;
  const endEntry = Math.min(startEntry + pageSize - 1, total);

  // Helper to create a list of visible page numbers with ellipsis
  const getVisiblePages = () => {
    const pages = [];
    if (totalPages <= 10) {
      // If there are 10 or fewer pages, show them all.
      for (let i = 0; i < totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show first and last pages.
      pages.push(0);

      // Determine range around current page.
      const left = Math.max(currentPage - 1, 1);
      const right = Math.min(currentPage + 1, totalPages - 2);

      // Add ellipsis if there's a gap between the first page and the start of the range.
      if (left > 1) {
        pages.push("start-ellipsis");
      }

      // Add pages around current page.
      for (let i = left; i <= right; i++) {
        pages.push(i);
      }

      // Add ellipsis if there's a gap between the end of the range and the last page.
      if (right < totalPages - 2) {
        pages.push("end-ellipsis");
      }

      pages.push(totalPages - 1);
    }
    return pages;
  };

  const visiblePages = getVisiblePages();
  return (
    <CustomPaginationContainer
      handlePageChange={onClick}
      total={total}
      startEntry={startEntry}
      endEntry={endEntry}
      pageSize={pageSize}
      currentPage={currentPage}
      visiblePages={visiblePages}
      totalPages={totalPages}
    />
  );
};

export default CustomPagination;
